import http from '@/utils/http.js'
/*
 * @DESC:mgapi接口
 */
const   BUSINESS_LIST = "/mgapi/getBusinessList",
		SAVE_BUSINESS = "/mgapi/saveBusiness",
		BUSINESS_INFO = "/mgapi/getBusinessInfo",
		RESET_BUSINESS_PWD = "/mgapi/resetBusinessPwd",
		UPDATE_BUSINESS_STATUS = "/mgapi/updateBusinessStatus"
	
export default {
	getBusinessList: async({
		commit,
	}, params={}) => {
		try{
			const data = await http.get(BUSINESS_LIST, params)
			commit('BUSINESS_LIST', data);
		}catch(e){
			throw e
		}
	},
	saveBusiness: async({
		commit,
	}, params={}) => {
		return http.post(SAVE_BUSINESS, params)
	},
	delBusiness: async({
		commit,
	}, params={}) => {
		return http.post(DEL_BUSINESS, params)
	},
	resetBusinessPwd: async({
		commit,
	}, params={}) => {
		return http.post(RESET_BUSINESS_PWD, params)
	},
	updateBusinessStatus: async({
		commit,
	}, params={}) => {
		return http.post(UPDATE_BUSINESS_STATUS, params)
	},
	getBusinessInfo: async({
		commit,
	}, params={}) => {
		return http.get(BUSINESS_INFO, params)
	}
}


// WEBPACK FOOTER //
// ./src/store/mg/business/actions.js